<template>
  <div>
    <v-btn
      color="grey"
      :disabled="delayImport"
      :loading="loading"
      outline
      @click="onClickUploadButton"
    >
      <i class="fas fa-file-import"></i>
      &nbsp;
      {{ $t('import') }}
    </v-btn>
    <input
      type="file"
      class="form-control-file pt-2"
      name="csvUpload"
      :id="'csvUpload'"
      data-vv-as="File"
      v-validate="'mimes:text/xlsx'"
      accept=".xlsx"
      @input="onFileChange($event)"
      style="overflow: hidden;position: fixed;width: 1px;height: 1px;z-index: -1;opacity: 0;"
    />
  </div>
</template>

<script>
import parser from 'simple-excel-to-json'
import XLSX from 'xlsx'
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      delayImport: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    onClickUploadButton() {
      document.getElementById('csvUpload').click()
    },
    onFileChange(event) {
      let vm = this
      vm.loading = true
      let files = event.target.files || event.dataTransfer.files
      var myFile = files[0]
      var reader = new FileReader()
      reader.onload = function(e) {
        var data = new Uint8Array(e.target.result)
        var workbook = XLSX.read(data, { type: 'array' })

        /* DO SOMETHING WITH workbook HERE */
        var result = []
        for (var sheet in workbook.Sheets) {
          result.push(vm.trimObj(XLSX.utils.sheet_to_json(workbook.Sheets[sheet])))
        }

        vm.uploadExcel(result)
      }
      reader.readAsArrayBuffer(myFile)
    },
    trimObj(obj) {
      var vm = this
      if (!Array.isArray(obj) && typeof obj != 'object') return obj
      return Object.keys(obj).reduce(
        function(acc, key) {
          acc[key.trim()] = typeof obj[key] == 'string' ? obj[key].trim() : vm.trimObj(obj[key])
          return acc
        },
        Array.isArray(obj) ? [] : {}
      )
    },
    uploadExcel(file) {
      var vm = this
      // var productlength = 0
      // file[1].map((el) => {
      //   var op1 = el.Option1Detail ? el.Option1Detail.split(',').length : 0
      //   var op2 = el.Option2Detail ? el.Option2Detail.split(',').length : 0
      //   if (op2) {
      //     productlength += op1 * op2
      //   } else productlength += op1
      // })
      if (file[2] && file.length == 3) {
        api.postuploadproducts(
          {
            products: file,
            pageid: this.selectedBot.pageid,
            isCentral: this.$store.state.centralPage.includes(this.selectedBot.pageid),
          },
          (err, response) => {
            this.loading = false
            if (response.responsecode == 200) {
              vm.$swal
                .fire({
                  type: 'success',
                  text: 'นำเข้าสินค้าสำเร็จ'
                })
                .then(result => {
                  window.location.reload()
                })
            } else {
              this.$swal.fire({
                text: 'รูปแบบข้อมูลไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง'
              })
            }
          }
        )
      } else {
        this.$swal.fire({
          text: 'รูปแบบข้อมูลไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง'
        })
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ImportShop.vue